import React from 'react';

export function AttachMoneyIcon({ ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 48 48"
      {...props}
    >
      <path d="M23.6 21.8c-4.54-1.18-6-2.4-6-4.3 0-2.18 2.02-3.7 5.4-3.7 3.09 0 4.493 1.28 4.887 3.254.105.523.532.946 1.066.946h2.425c.569 0 1.029-.475.939-1.036-.484-3.023-2.56-5.667-6.317-6.584V7a1 1 0 00-1-1h-4a1 1 0 00-1 1v3.32c-3.88.84-7 3.36-7 7.22 0 4.62 3.82 6.92 9.4 8.26 5 1.2 6 2.96 6 4.82 0 1.38-.98 3.58-5.4 3.58-3.581 0-5.274-1.39-5.8-3.304-.136-.498-.555-.896-1.071-.896h-2.433c-.573 0-1.036.485-.935 1.05.667 3.726 3.717 5.858 7.239 6.61V41a1 1 0 001 1h4a1 1 0 001-1v-3.3c3.9-.74 7-3 7-7.1 0-5.68-4.86-7.62-9.4-8.8z" />
    </svg>
  );
}
